const titleFontHolder = document.querySelector('h1.product__title .font-name');
const nameInputs = document.querySelectorAll('.input-name');
let ringSizeInputs = [];
const ringSizeInputsFirstType = document.querySelectorAll("input[name='properties[Ring size]']");
const ringSizeInputsSecondType = document.querySelectorAll(
	"input[name='items[0][properties[Ring size]]']",
);
if (ringSizeInputsFirstType.length) {
	ringSizeInputs = ringSizeInputsFirstType;
} else if (ringSizeInputsSecondType.length) {
	ringSizeInputs = ringSizeInputsSecondType;
}
const getVisibleItemProperties = (item) => {
	const filteredProperties = Object.entries(item.properties).filter((el) => {
		const firstSymbol = el[0].split('')[0];
		if (firstSymbol === '_' && el[1].includes('View picture')) {
			return el;
		} else if (firstSymbol !== '_' && el[0] !== 'Saint Name') {
			return el;
		} else {
			return;
		}
	});
	filteredProperties.forEach((el) => {
		const firstSymbol = el[0].split('')[0];
		if (firstSymbol === '_') {
			el[0] = el[0].substring(1);
		}
	});
	return filteredProperties;
};

window.getVisibleItemProperties = getVisibleItemProperties;

const getItemUrl = (item) => {
	const isFullUrl = item.properties['_full-url'];
	return isFullUrl ? isFullUrl : item.url;
};

window.getItemUrl = getItemUrl;

const getItemTitle = (item) => {
	const isOriginalTitle = item.properties['_Original Product Name'];
	return isOriginalTitle ? isOriginalTitle : item.product_title;
};

window.getItemTitle = getItemTitle;
function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
		),
	);
}

const countdownTimer = document.querySelector('#countdown-timer');
if (countdownTimer && countdownTimer.dataset.endDate) {
	const endDate = countdownTimer.dataset.endDate;
	const timeZone = countdownTimer.dataset.timeZone;
	let countDownDate = new Date(endDate).getTime();
	const d = new Date();
	let now = new Date(d.toLocaleString('en-US', { timeZone: timeZone })).getTime();

	let distance = countDownDate - now;
	const timerSection = countdownTimer.closest('.countdown-timer-container');
	if (distance > 0) {
		timerSection.style.display = 'block';
	}
	// const timerSections = document.querySelectorAll('.countdown-timer-section');
	let x = setInterval(() => {
		const d = new Date();
		let now = new Date(d.toLocaleString('en-US', { timeZone: timeZone })).getTime();

		let distance = countDownDate - now;

		let days = Math.floor(distance / (1000 * 60 * 60 * 24));
		let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		let seconds = Math.floor((distance % (1000 * 60)) / 1000);

		countdownTimer.innerHTML = `<div class="countdown-timer__time-characters"><p>${days}</p><p>days</p></div> | <div class="countdown-timer__time-characters"><p>${hours}</p><p>hours</p></div> | <div class="countdown-timer__time-characters"><p>${minutes}</p><p>minutes</p></div> | <div class="countdown-timer__time-characters"><p>${seconds}</p><p>seconds</p></div>`;

		if (distance < 0) {
			timerSection.style.display = 'none';
			// timerSections.forEach((el) => {
			// 	el.style.display = 'none';
			// });
			clearInterval(x);
		}
	}, 1000);
}

document.addEventListener('rebuy:cart.change', (event) => {
	const cartItems = event.detail.cart.cart.item_count;
	const cartIcon = document.querySelector('.header__icon--cart .icon-cart');
	const cartEmptyIcon = document.querySelector('.header__icon--cart .icon-cart-empty');
	const bubbleContaintr = document.querySelector('.cart-count-bubble');
	if (cartItems < 1) {
		cartIcon.style.display = 'none';
		bubbleContaintr.style.display = 'none';
		cartEmptyIcon.style.display = 'block';
	}
	if (cartItems > 0) {
		const bubble = document.querySelector('.cart-count-bubble span');
		cartIcon.style.display = 'block';
		cartEmptyIcon.style.display = 'none';
		bubbleContaintr.style.display = 'block';
		bubble.style.display = 'flex';
		bubble.textContent = `${cartItems}`;

		chainAsProductPropertyValidate(event.detail.cart);
		backEngravingProductPropertyValidate(event.detail.cart);
	}
});
function backEngravingProductPropertyValidate(cart) {
	const items = cart.cart.items;
	const mainProducts = items.filter((item) => item.properties['_Pendant Back Side']);
	mainProducts.map((product) => {
		const mainTimestamp = product.properties['_Timestamp'];
		if (mainTimestamp) {
			const backEngravingProduct = items.find(
				(item) => item.properties['_Timestamp'] == mainTimestamp && item.id != product.id,
			);
			if (!backEngravingProduct) {
				removeProperty(cart, product, ['_Pendant Back Side', '_Timestamp', '_full-url']);
			}
		}
	});

	function removeProperty(cart, item, property) {
		console.log('');
		const properties = { ...item.properties };
		property.forEach((prop) => delete properties[prop]);
		cart.changeItem({
			id: item.key,
			quantity: item.quantity,
			properties,
		});
	}
}

function chainAsProductPropertyValidate(cart) {
	const items = cart.cart.items;

	const mainProducts = items.filter((item) => item.properties['_Chain_Length']);
	const mainProductsQuantity = mainProducts.length ? getProductQuantity(mainProducts) : 0;
	const chainAsProduct = items.filter((item) => item.properties['_Main_Product']);
	const chainAsProductQuantity = chainAsProduct.length ? getProductQuantity(chainAsProduct) : 0;

	if (mainProductsQuantity != chainAsProductQuantity) {
		chainAsProduct.map((chain) => {
			const mainProductSKU = chain.properties['_Main_Product'];
			const chainProductTitle = chain.variant_title;
			if (mainProductSKU) {
				const mainProductChain =
					mainProducts.find(
						(product) =>
							product.sku == mainProductSKU &&
							product.properties['_Chain_Length'] == chainProductTitle,
					) ||
					mainProducts.find(
						(product) =>
							product.title == mainProductSKU &&
							product.properties['_Chain_Length'] == chainProductTitle,
					);
				if (!mainProductChain) {
					removeProperty(cart, chain, '_Main_Product', chain.quantity);
				} else if (chain.quantity > mainProductChain.quantity) {
					removeProperty(cart, chain, '_Main_Product');
				}
			}
		});
		mainProducts.map((product) => {
			const chainProductTitle = product.properties['_Chain_Length'];
			if (chainProductTitle) {
				const chainProduct = chainAsProduct.find(
					(chain) => chain.variant_title == chainProductTitle,
				);
				if (!chainProduct) {
					removeProperty(cart, product, '_Chain_Length', product.quantity);
				} else if (product.quantity > chainProduct.quantity) {
					removeProperty(cart, product, '_Chain_Length');
				}
			}
		});
	}

	function getProductQuantity(items) {
		return items.map((item) => item.quantity)?.reduce((acc, curr) => acc + curr, 0) || 0;
	}

	function removeProperty(cart, item, property, quantity) {
		const properties = { ...item.properties };
		if (quantity === 1) {
			delete properties[property];
			cart.changeItem({
				id: item.key,
				quantity: quantity,
				properties,
			});
		} else {
			// if the quantity is more than 1, we need to change the item and add a new one with the property removed
			quantity = 1;
			const lastQuantity = item.quantity - quantity;
			if (lastQuantity > 0) {
				cart.changeItem({
					id: item.key,
					quantity: lastQuantity,
					properties,
				});

				const newProperties = { ...properties };
				delete newProperties[property];
				cart.addItem({
					id: item.variant_id,
					quantity: quantity,
					properties: newProperties,
				});
			}
		}
	}
}

const isArrayEquals = (a, b) => {
	if (a.length !== b.length) {
		return false;
	}
	const uniqueValues = new Set([...a, ...b]);
	for (const v of uniqueValues) {
		const aCount = a.filter((e) => e === v).length;
		const bCount = b.filter((e) => e === v).length;
		if (aCount !== bCount) {
			return false;
		}
	}
	return true;
};
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button');
	summary.setAttribute('aria-expanded', 'false');

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id);
	}

	let summaryTop = window.scrollY;

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open'),
		);

		summaryTop = window.scrollY;
	});

	if (summary.closest('.product__accordion')) {
		summary.closest('details').addEventListener('toggle', () => {
			window.scrollTo({ top: summaryTop });
		});
	}

	if (summary.closest('header-drawer')) return;
	summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;

		document.addEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);

	elementToFocus?.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(':focus-visible');
} catch (e) {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = [
		'ARROWUP',
		'ARROWDOWN',
		'ARROWLEFT',
		'ARROWRIGHT',
		'TAB',
		'ENTER',
		'SPACE',
		'ESCAPE',
		'HOME',
		'END',
		'PAGEUP',
		'PAGEDOWN',
	];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener('keydown', (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener('mousedown', (event) => {
		mouseClick = true;
	});

	window.addEventListener(
		'focus',
		() => {
			if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

			if (mouseClick) return;

			currentFocusedElement = document.activeElement;
			currentFocusedElement.classList.add('focused');
		},
		true,
	);
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*',
		);
	});
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	document.querySelectorAll('video').forEach((video) => video.pause());
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;

	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', false);
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', { bubbles: true });

		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onButtonClick.bind(this)),
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};

	var form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (var key in params) {
		var hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default');
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default');
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute('data-provinces');
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none';
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option');
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = '';
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option');
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector('details');

		if (navigator.userAgentData?.platform === 'iOS')
			document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

		this.addEventListener('keyup', this.onKeyUp.bind(this));
		this.addEventListener('focusout', this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this)),
		);
		this.querySelectorAll('button:not([data-submit-button])').forEach((button) =>
			button.addEventListener('click', this.onCloseButtonClick.bind(this)),
		);
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		const openDetailsElement = event.target.closest('details[open]');
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute('open');
		const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

		function addTrapFocus() {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
			summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
		}

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
		} else {
			setTimeout(() => {
				detailsElement.classList.add('menu-opening');
				summaryElement.setAttribute('aria-expanded', true);
				!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener('transitionend', () => {
							addTrapFocus();
					  });
			}, 100);
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening');
		});
		summaryElement.setAttribute('aria-expanded', true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event === undefined) return;

		this.mainDetailsToggle.classList.remove('menu-opening');
		this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
			details.removeAttribute('open');
			details.classList.remove('menu-opening');
		});
		document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
		removeTrapFocus(elementToFocus);
		this.closeAnimation(this.mainDetailsToggle);

		this.dispatchEvent(new CustomEvent('close-menu-drawer'));
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details');
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening');
		detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
		removeTrapFocus(detailsElement.querySelector('summary'));
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute('open');
				if (detailsElement.closest('details[open]')) {
					trapFocus(
						detailsElement.closest('details[open]'),
						detailsElement.querySelector('summary'),
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.getElementById('shopify-section-header');
		this.borderOffset =
			this.borderOffset ||
			this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
				? 1
				: 0;
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
		);
		this.header?.classList?.add('menu-open');

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening');
		});

		summaryElement.setAttribute('aria-expanded', true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus) {
		super.closeMenuDrawer(event, elementToFocus);
		this.header?.classList?.remove('menu-open');
	}
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]')?.addEventListener('click', this.hide.bind(this));
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide();
		});
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-mode'))
					this.hide();
			});
		} else {
			this.addEventListener('click', (event) => {
				if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector('.template-popup');
		document.body.classList.add('overflow-hidden');
		this.setAttribute('open', '');
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		document.body.classList.remove('overflow-hidden');
		this.removeAttribute('open');
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector('button');

		if (!button) return;
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'));
			if (modal) modal.show(button);
		});
	}
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener('click', this.loadContent.bind(this));
	}

	loadContent(event, focus = true) {
		const mediaVideo = event.currentTarget.closest('li[video-element]');
		if (mediaVideo) {
			const playVideo = mediaVideo.querySelector('[play-video-button]');
			playVideo.classList.add('hidden');
		}
		window.pauseAllMedia();
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

			this.setAttribute('loaded', true);
			const deferredElement = this.appendChild(
				content.querySelector('video, model-viewer, iframe'),
			);
			if (focus) deferredElement.focus();
		}
	}
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();

		this.slider = this.querySelector('[id^="Slider-"]');
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.enableSliderLooping = false;
		this.currentPageElement = this.querySelector('.slider-counter--current');
		this.pageTotalElement = this.querySelector('.slider-counter--total');
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');
		this.playVideoButtons = this.querySelectorAll('button[play-video-button]');

		if (!this.slider || !this.nextButton) return;
		this.mediaGallery = this.closest('media-gallery');
		this.sliderScrollBars = this.mediaGallery.querySelectorAll('[data-slider-scroll-bar]');
		this.initPages();
		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener('scroll', this.update.bind(this));
		this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
		this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

		this.sliderScrollBars.forEach((bar) => {
			bar.addEventListener('click', this.onScrollBarClick.bind(this));
		});
		if (this.playVideoButtons.length != 0) {
			this.playVideoButtons.forEach((button) =>
				button.addEventListener('click', this.scrollToVideo.bind(this)),
			);
		}
	}

	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter(
			(element) => element.clientWidth > 0,
		);
		if (this.sliderItemsToShow.length < 2) return;
		this.sliderItemOffset =
			this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
		this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
		this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
		this.videoSlide = this.sliderItemsToShow.find((item) => item.hasAttribute('video-element'));
		this.isVideoPlayButtonClick = false;

		this.update();
	}

	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.initPages();
	}

	update() {
		const previousPage = this.currentPage;
		this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

		if (this.currentPageElement && this.pageTotalElement) {
			this.currentPageElement.textContent = this.currentPage;
			this.pageTotalElement.textContent = this.totalPages;
		}

		if (this.currentPage != previousPage) {
			this.dispatchEvent(
				new CustomEvent('slideChanged', {
					detail: {
						currentPage: this.currentPage,
						currentElement: this.sliderItemsToShow[this.currentPage - 1],
					},
				}),
			);

			this.scrollBarChange();
		}

		if (this.enableSliderLooping) return;

		if (this.isSlideVisible(this.sliderItemsToShow[0])) {
			this.prevButton.setAttribute('disabled', 'disabled');
		} else {
			this.prevButton.removeAttribute('disabled');
		}

		if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
			this.nextButton.setAttribute('disabled', 'disabled');
		} else {
			this.nextButton.removeAttribute('disabled');
		}

		if (this.isVideoPlayButtonClick && this.isSlideVisible(this.videoSlide)) {
			setTimeout(() => {
				this.videoSlide.querySelector('modal-opener .product__media-toggle').click();
			}, 350);

			this.isVideoPlayButtonClick = false;
		}
	}

	scrollBarChange() {
		if (window.innerWidth < 749 && this.sliderScrollBars && this.sliderScrollBars.length != 0) {
			console.log('this.currentPage', this.currentPage);
			this.sliderScrollBars.forEach((bar) => {
				const barIndex = bar.getAttribute('data-index');
				const isCurrent = barIndex == this.currentPage;
				bar.classList.toggle('active', isCurrent);
				if (barIndex <= this.totalPages) {
					bar.classList.toggle('show', true);
				}
			});
		}
	}
	scrollToVideo(e) {
		const viewportWidth = document.documentElement.clientWidth;
		if (viewportWidth < 749) {
			const videoSlidePosition = this.videoSlide.offsetLeft;

			const button = this.videoSlide.querySelector('modal-opener .product__media-toggle');
			const isCurrentSlideVideo = e.target.closest('[video-element]');
			const timeOut = isCurrentSlideVideo ? 0 : 1000;

			button.focus();
			this.slider.scrollTo({
				left: videoSlidePosition,
				behavior: 'smooth',
			});
			const mediaId =
				button.getAttribute('data-media-id') || button.getAttribute('data-media-slide-id');
			// const photoswipeItem = document.querySelector(
			// 	`.photoswipe-gallery__item[data-media-reference-id="${mediaId}"]`,
			// );
			setTimeout(() => {
				button.click();
			}, timeOut);
		} else {
			const mediaToggle = this.videoSlide.querySelector('.deffered-media-toggle');
			mediaToggle.click();

			const mediaId =
				this.videoSlide.getAttribute('data-media-id') ||
				this.videoSlide.getAttribute('data-media-slide-id');
			const photoswipeItem = document.querySelector(`#Slide-${mediaId}`);
			const photoswipeButton = photoswipeItem.querySelector('.deferred-media__poster');

			setTimeout(() => {
				photoswipeButton.click();
			}, 100);
		}
	}

	isSlideVisible(element, offset = 0) {
		const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
		return (
			element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
			element.offsetLeft >= this.slider.scrollLeft
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const step = event.currentTarget.dataset.step || 1;
		this.slideScrollPosition =
			event.currentTarget.name === 'next'
				? this.slider.scrollLeft + step * this.sliderItemOffset
				: this.slider.scrollLeft - step * this.sliderItemOffset;
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		});
	}

	onScrollBarClick(event) {
		const targetTab = event.currentTarget;
		const targetIndex = targetTab.getAttribute('data-index');
		const side = this.currentPage > targetIndex ? 'previous' : 'next';
		const step = Math.abs(this.currentPage - targetIndex);
		this.slideScrollPosition =
			side === 'next'
				? this.slider.scrollLeft + step * this.sliderItemOffset
				: this.slider.scrollLeft - step * this.sliderItemOffset;

		this.slider.scrollTo({
			left: this.slideScrollPosition,
			behavior: 'smooth',
		});
	}
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
	constructor() {
		super();
		this.sliderControlWrapper = this.querySelector('.slider-buttons');
		this.enableSliderLooping = true;

		if (!this.sliderControlWrapper) return;

		this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
		if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

		this.sliderControlLinksArray = Array.from(
			this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
		);
		this.sliderControlLinksArray.forEach((link) =>
			link.addEventListener('click', this.linkToSlide.bind(this)),
		);
		this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
		this.setSlideVisibility();

		if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
	}

	setAutoPlay() {
		this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
		this.autoplaySpeed = this.slider.dataset.speed * 1000;

		this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
		this.addEventListener('mouseover', this.focusInHandling.bind(this));
		this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
		this.addEventListener('focusin', this.focusInHandling.bind(this));
		this.addEventListener('focusout', this.focusOutHandling.bind(this));

		this.play();
		this.autoplayButtonIsSetToPlay = true;
	}

	onButtonClick(event) {
		super.onButtonClick(event);
		const isFirstSlide = this.currentPage === 1;
		const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

		if (!isFirstSlide && !isLastSlide) return;

		if (isFirstSlide && event.currentTarget.name === 'previous') {
			this.slideScrollPosition =
				this.slider.scrollLeft +
				this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
		} else if (isLastSlide && event.currentTarget.name === 'next') {
			this.slideScrollPosition = 0;
		}
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		});
	}

	update() {
		super.update();
		this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
		this.prevButton.removeAttribute('disabled');

		if (!this.sliderControlButtons.length) return;

		this.sliderControlButtons.forEach((link) => {
			link.classList.remove('slider-counter__link--active');
			link.removeAttribute('aria-current');
		});
		this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
		this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
	}

	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
		this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
		this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
	}

	focusOutHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton ||
			this.sliderAutoplayButton.contains(event.target);
		if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
		this.play();
	}

	focusInHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton ||
			this.sliderAutoplayButton.contains(event.target);
		if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
			this.play();
		} else if (this.autoplayButtonIsSetToPlay) {
			this.pause();
		}
	}

	play() {
		this.slider.setAttribute('aria-live', 'off');
		clearInterval(this.autoplay);
		this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
	}

	pause() {
		this.slider.setAttribute('aria-live', 'polite');
		clearInterval(this.autoplay);
	}

	togglePlayButtonState(pauseAutoplay) {
		if (pauseAutoplay) {
			this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
			this.sliderAutoplayButton.setAttribute(
				'aria-label',
				window.accessibilityStrings.playSlideshow,
			);
		} else {
			this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
			this.sliderAutoplayButton.setAttribute(
				'aria-label',
				window.accessibilityStrings.pauseSlideshow,
			);
		}
	}

	autoRotateSlides() {
		const slideScrollPosition =
			this.currentPage === this.sliderItems.length
				? 0
				: this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}

	setSlideVisibility() {
		this.sliderItemsToShow.forEach((item, index) => {
			const button = item.querySelector('a');
			if (index === this.currentPage - 1) {
				if (button) button.removeAttribute('tabindex');
				item.setAttribute('aria-hidden', 'false');
				item.removeAttribute('tabindex');
			} else {
				if (button) button.setAttribute('tabindex', '-1');
				item.setAttribute('aria-hidden', 'true');
				item.setAttribute('tabindex', '-1');
			}
		});
	}

	linkToSlide(event) {
		event.preventDefault();
		const slideScrollPosition =
			this.slider.scrollLeft +
			this.sliderFirstItemNode.clientWidth *
				(this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', (e) => {
			const isInputWithFont = e.target.name === 'Font';
			const isInputWithMetal = e.target.name === 'Metal';
			const metalColor = e.target.dataset.metalHandle;
			this.onVariantChange(isInputWithFont, isInputWithMetal, metalColor);
		});
		this.updateOptions();
		this.updateMasterId();
	}

	onVariantChange(isInputWithFont, isInputWithMetal, metalColor) {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, '', false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		// this.updateTitle();

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateMedia(false, isInputWithMetal);

			this.updateImageBlock(isInputWithMetal, metalColor);
			this.updateTextInputColors(isInputWithMetal, metalColor);
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.updateShareUrl();
		}
	}

	updateTextInputColors(isInputWithMetal, metalColor) {
		const isEngravingProduct = document.querySelector('.product').getAttribute('data-engraving');
		const textInput = Array.from(document.querySelectorAll('.input-name'));
		if ((!isInputWithMetal && !textInput.length) || !isEngravingProduct) return;
		switch (metalColor) {
			case 'yellow':
				textInput.forEach((el) => {
					el.style.backgroundColor = '#ffefbf';
					el.style.color = '#dcbe7e';
					el.style.textShadow = '0 -1px .5px rgb(173,125,40),0 1px .5px rgb(255,255,255)';
					el.dispatchEvent(new Event('blur'));
				});
				break;
			case 'rose':
				textInput.forEach((el) => {
					el.style.backgroundColor = '#fee0c8';
					el.style.color = '#dbb497';
					el.style.textShadow = '0 -1px .5px rgba(183,95,47,255),0 1px .5px rgb(255,255,255)';
					el.dispatchEvent(new Event('blur'));
				});
				break;
			case 'white':
				textInput.forEach((el) => {
					el.style.backgroundColor = '#dedede';
					el.style.color = '#acacac';
					el.style.textShadow = '0 -1px .5px rgba(98,98,98,255),0 1px .5px rgb(255,255,255)';
					el.dispatchEvent(new Event('blur'));
				});
		}
	}

	updateTitle() {
		const fontInputs = Array.from(this.querySelectorAll('fieldset input[name="Font"]'));
		if (fontInputs.length) {
			const fontName = fontInputs.find((radio) => radio.checked).value;
			titleFontHolder.innerHTML = `in ${fontName} Font`;
		}
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return isArrayEquals(variant.options, this.options);
		});
	}

	updateChainOptions(metalValue) {
		const productType = this.dataset.productType.toLowerCase();
		if (productType !== 'necklace') return;
		const lengthSelector = document.querySelector('length-selector');
		if (lengthSelector) return;
		const chainIputs = document.querySelectorAll('input[name="Chain Length"]');

		const variants = this.getVariantData();
		const fullVariant = variants.find((el) => {
			return el.options.includes(metalValue);
		});

		const metalDataJson = document.getElementById('metalDataJson');
		const metalDataArr = JSON.parse(metalDataJson.textContent);
		const metalNames = metalDataArr.map((el) => el.name);
		const metalOption = fullVariant.options.find((el) => {
			return metalNames.includes(el);
		});
		const metalOptionIndex = fullVariant.options.findIndex((item) => item === metalOption);

		const chainDataJson = document.getElementById('chainDataJson');
		const chainDataArr = JSON.parse(chainDataJson.textContent);
		const chainNames = chainDataArr.map((el) => el.name);
		const chainOption = fullVariant.options.find((el) => {
			return chainNames.includes(el);
		});
		const chainOptionIndex = fullVariant.options.findIndex((item) => item === chainOption);

		const variantChainOptions = variants.filter(
			(variant) => variant.options[metalOptionIndex] === fullVariant.options[metalOptionIndex],
		);

		const filteredVariantChainOptions = variantChainOptions
			.filter(
				(el, index) =>
					variantChainOptions.findIndex(
						(item) => item.options[chainOptionIndex] === el.options[chainOptionIndex],
					) === index,
			)
			.map((el) => el.options[chainOptionIndex]);

		const chainIputValues = Array.from(chainIputs).map((el) => el.value);
		const extraChainValues = chainIputValues.filter(
			(el) => !filteredVariantChainOptions.includes(el),
		);

		if (extraChainValues.length) {
			Array.from(chainIputs).forEach((el) => {
				if (extraChainValues.includes(el.value)) {
					el.closest('.custom-option').style.display = 'none';
					el.classList.add('hiiden-option');
					el.closest('.custom-option').classList.remove('active');

					if ('checked' in el) {
						el.checked = false;
					}
				} else {
					el.classList.remove('hiiden-option');
					el.closest('.custom-option').style.display = 'flex';
				}
			});
		} else {
			Array.from(chainIputs).forEach((el) => {
				el.closest('.custom-option').style.display = 'flex';
				el.classList.remove('hiiden-option');
			});
		}
	}

	updateMedia(isInputWithFont, isInputWithMetal) {
		if (!this.currentVariant) return;
		if (!this.currentVariant.featured_media) return;

		const imageUrlHiddenInput = document.querySelector('input.image-url');
		imageUrlHiddenInput.value = this.currentVariant.featured_image.src.replace(/^\/\//, 'https://');
		const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
		let inputsConcatValue = '';
		const singleNameInput = nameInputs[0];
		const defaultInputValue = singleNameInput ? singleNameInput.dataset.defaultValue : undefined;

		nameInputs.forEach((input) => {
			if (input.value) {
				inputsConcatValue += input.value;
			}
		});
		const checkIsRenderRequired = (inputs) => {
			let noRenderStatus = false;
			inputs.forEach((input) => {
				const isMultiplyNameInput = input.classList.contains('input-multiple-name');
				const isNoRenderImageInput = input.classList.contains('input-name-necklace-no-render');
				noRenderStatus = isMultiplyNameInput || isNoRenderImageInput;
			});
			return noRenderStatus;
		};

		const isCharactersEnough = (node) => {
			const minNumberOfCharacters = node.dataset.minNumberOfCharacters;
			const isInputEmpty = node.value.length === 0;
			return node.value.length >= minNumberOfCharacters || isInputEmpty;
		};

		const noRender = nameInputs.length ? checkIsRenderRequired(nameInputs) : true;
		const isInitial = document.querySelectorAll('#input-initial').length;

		if (noRender) {
			const featuredImgSrc = this.currentVariant.featured_image.src;
			const productSku = this.currentVariant.sku?.split('-')[0];
			mediaGallery.setActiveMedia(
				`${this.dataset.section}-${this.currentVariant.featured_media.id}`,
				true,
				isInputWithFont,
				featuredImgSrc,
				noRender,
				productSku,
				isInitial,
				isInputWithMetal,
			);
		} else {
			if (isCharactersEnough(singleNameInput)) {
				const imgHolder = document.querySelector(
					'#generated-product-img, #generated-product-img-static',
				);
				const imgHolderParent = imgHolder.closest("li[id^='Slide-template']");
				const imgMediaId = imgHolderParent.dataset.mediaId;
				const featuredImgSrc = this.currentVariant.featured_image.src;
				const productSku = this.currentVariant.sku.split('-')[0];
				mediaGallery.setActiveMedia(
					`${this.dataset.section}-${this.currentVariant.featured_media.id}`,
					true,
					isInputWithFont,
					featuredImgSrc,
					noRender,
					productSku,
					isInitial,
					isInputWithMetal,
				);
				window.handleImageUpdate(
					singleNameInput,
					inputsConcatValue.length ? inputsConcatValue : defaultInputValue,
					isInputWithMetal,
				);
			}
		}

		window.hideImagesByMetal();
	}

	updateParentChainProduct(isMetalInput) {
		if (!isMetalInput) return;
		const metalOptionInputs = document.querySelectorAll('input[name="Metal"]');
		const chainLengthOptions = document.querySelectorAll('.chain-products__length-option');
		const chainMetalOptions = document.querySelectorAll(
			'.chain-products__chain-metal-option:not(.chain-products__no-chain-option):not(.show-all)',
		);
		const chainMetalOptionsShowAll = document.querySelectorAll(
			'.chain-products__chain-metal-option.show-all',
		);
		if (!chainMetalOptions.length) return;
		const activeMetalInput = Array.from(metalOptionInputs).find((el) =>
			el.closest('.custom-option').classList.contains('active'),
		);
		const activeMetalValue = activeMetalInput.value;
		Array.from(chainMetalOptions).forEach((el) => el.classList.remove('active', 'from-show-all'));
		Array.from(chainMetalOptionsShowAll).forEach((el) => el.classList.remove('active'));
		Array.from(chainLengthOptions).forEach((el) => el.classList.remove('active'));
		Array.from(chainMetalOptions).forEach((el) => {
			const chainMetalValue = el.dataset.chainMetalValue;
			activeMetalValue !== chainMetalValue
				? el.classList.remove('active-metal')
				: el.classList.add('active-metal');
		});
		this.updateURL();
		window.setPriceAccordingPickedOptions();
	}

	updateImageBlock(isInputWithMetal, metalColor) {
		if (!this.currentVariant) return;

		if (isInputWithMetal) {
			const imageItems = document.querySelectorAll('.option-custom-image-block');
			const imageItemsArray = Array.from(imageItems);
			imageItemsArray.forEach((item) => {
				let image = item.querySelector('img');
				let colorUrl = image.getAttribute(`data-${metalColor}`);

				image.setAttribute('src', `${colorUrl}`);
			});

			let inputs = document.querySelectorAll('.image-trigger');
			let inputsArray = Array.from(inputs);
			inputsArray.forEach((item) => {
				let inputValue = item.getAttribute('data-value');
				let originalName = item.getAttribute('data-name');

				let currentBlock = document.querySelector(`.${originalName}`);
				const imageBlocks = currentBlock.querySelectorAll('.option-custom-image-block');
				let imageBlocksArray = Array.from(imageBlocks);
				imageBlocksArray.forEach((block) => {
					if (block.classList.contains('active')) {
						let link = block.querySelector('img').getAttribute(`data-${metalColor}`);
						item.setAttribute(
							'value',
							`${inputValue} <a href="${link}" target="_blank">View picture</a>`,
						);
					}
				});
			});
		} else {
			return;
		}
	}

	getRingSizeProperty() {
		const ringSizeCheckedInput = Array.from(ringSizeInputs).find((input) => input.checked);

		const ringSizeValue = ringSizeCheckedInput ? ringSizeCheckedInput.value : undefined;
		return ringSizeValue ? `&ringSize=${ringSizeValue}` : '';
	}

	getNameProperty() {
		const nameValue = Array.from(nameInputs)
			.map((input) => input.value.replaceAll(/(\r\n|\r|\n)/g, '\\n'))
			.join('|');
		return nameValue === '||' || !nameValue.length ? '' : `&name=${nameValue}`;
	}

	getLengthProperty() {
		const lengthSelector = document.querySelector('length-selector');
		if (!lengthSelector) return '';

		const lengthType = lengthSelector.getAttribute('data-option-name');
		const propertyName = lengthType == 'Chain Length' ? 'chain-length' : 'bracelet-length';

		const activeOption = lengthSelector.querySelector('.custom-option.active');
		const propertyValue = activeOption ? activeOption.getAttribute('data-length-option') : '';

		return propertyValue ? `&${propertyName}=${propertyValue}` : '';
	}

	getChainVariantId() {
		const chainMetalOptionEls = document.querySelectorAll(
			'[data-chain-metal-value]:not(.show-all)',
		);
		const chainAsOption = document.querySelector('chain-as-option');
		if (chainMetalOptionEls.length) {
			const chainLentgthOptionEls = document.querySelectorAll(
				'[data-chain-length-value]:not(.show-all)',
			);
			const chainMetalElements = document.querySelectorAll('[data-chain-products-metals]');
			const activeChainMetalOption = Array.from(chainMetalOptionEls)
				.find((el) => el.classList.contains('active'))
				?.getAttribute('data-chain-metal-value');
			const activeMetal = Array.from(chainMetalElements)
				.find((el) => el.classList.contains('active'))
				?.getAttribute('metal-value');
			const activeChainLengthOption = Array.from(chainLentgthOptionEls)
				.find((el) => el.classList.contains('active'))
				?.getAttribute('data-chain-length-value');
			const lengthValue = activeChainLengthOption ? `&length=${activeChainLengthOption}` : '';
			let metalValue = activeMetal ? `&metal=${activeMetal}` : '';
			if (!activeMetal) {
				metalValue = activeChainMetalOption ? `&metal=${activeChainMetalOption}` : '';
			}
			const noChainBtn = document.querySelector('.chain-products__no-chain-option.active');
			const noChainValue = noChainBtn ? `&no-chain=true` : '';
			let chainId = '';

			if (activeChainMetalOption) {
				const activeChainMetalId = Array.from(chainMetalOptionEls)
					.find((el) => el.classList.contains('active'))
					.getAttribute('data-chain-metal-option');
				chainId = `&chain-id=${activeChainMetalId}`;
			}

			if (activeChainLengthOption) {
				const activeChainLengthId = Array.from(chainLentgthOptionEls)
					.find((el) => el.classList.contains('active'))
					.getAttribute('data-chain-length-option');
				chainId = `&chain-id=${activeChainLengthId}`;
			}

			return noChainBtn ? noChainValue : lengthValue + metalValue + chainId;
		} else if (chainAsOption) {
			let params = '';
			const chainAsOptionEl = document.querySelector('chain-as-option');
			const chainTypeEl = chainAsOptionEl.querySelector('[data-chain-option-type].active');
			if (chainTypeEl) {
				params += '&chain-type=' + chainTypeEl.getAttribute('data-option-type');
			}
			const chainLengthEl = chainAsOptionEl.querySelector('[data-chain-length-option].active');
			if (chainLengthEl) {
				params += '&length=' + chainLengthEl.getAttribute('data-chain-length-option');
			}
			return params;
		} else {
			return '';
		}
	}

	getFontNmaeProperty() {
		const fontValue = Array.from(document.querySelectorAll('.custom-font-option.active input'))
			.map((input) => input.value)
			.join('|');

		return fontValue === '||' || !fontValue.length ? '' : `&font=${fontValue}`;
	}

	getBackEngravingParams() {
		const backEngravingEl = document.querySelector('back-engraving');
		const activeOption = backEngravingEl?.querySelector('[data-option-type].active');
		if (backEngravingEl && activeOption) {
			const type = activeOption.getAttribute('data-option-type');
			const saintParams = this.getSecondSaintParams();
			const typeParams = type ? '&back-engraving=' + type : '';
			return typeParams + saintParams;
		} else {
			return '';
		}
	}

	getSecondSaintParams() {
		const backEngravingEl = document.querySelector('back-engraving');
		if (backEngravingEl) {
			const activeOption = backEngravingEl.querySelector('[data-option-type].active');
			const isSaint = activeOption.getAttribute('data-second-saint');
			return isSaint ? `&second-saint=` + isSaint : '';
		}
	}

	updateURL() {
		const isAdditionalChainProduct = this.querySelector('.chain-products__wrapper');
		const isBackEngraving = this.querySelector('back-engraving');
		let canPressed = true;
		if (isBackEngraving) {
			canPressed = !!isBackEngraving.inited;
		}
		if (!canPressed) return;
		if (!this.currentVariant || this.dataset.updateUrl === 'false') {
			if (isAdditionalChainProduct) {
				window.history.replaceState(
					{},
					'',
					`${
						this.dataset.url
					}?variants=1${this.getNameProperty()}${this.getRingSizeProperty()}${this.getFontNmaeProperty()}${this.getChainVariantId()}${this.getLengthProperty()}${this.getBackEngravingParams()}`,
				);
			}
		} else {
			window.history.replaceState(
				{},
				'',
				`${this.dataset.url}?variant=${
					this.currentVariant.id
				}${this.getNameProperty()}${this.getRingSizeProperty()}${this.getFontNmaeProperty()}${this.getChainVariantId()}${this.getLengthProperty()}${this.getBackEngravingParams()}`,
			);
		}
	}

	updateShareUrl() {
		const shareButton = document.getElementById(`Share-${this.dataset.section}`);
		if (!shareButton) return;
		shareButton.updateUrl(
			`${window.shopUrl}${this.dataset.url}?variant=${
				this.currentVariant.id
			}${this.getNameProperty()}${this.getRingSizeProperty()}`,
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment`,
		);
		productForms.forEach((productForm) => {
			let input = productForm.querySelector('.id-input-1');

			if (!input) {
				input =
					productForm.querySelector('input[name="id"]') ||
					productForm.querySelector("input[name='items[0][id]']");
			}

			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		});

		const chainMainProduct = document.querySelector(
			"input[name='items[1][properties[_Main_Product]]']",
		);
		const backEngravingMainProduct = document.querySelector('.back-engraving-main-id');
		if (chainMainProduct) {
			chainMainProduct.value = this.currentVariant.sku;
		}
		if (backEngravingMainProduct) {
			backEngravingMainProduct.value = this.currentVariant.sku;
		}
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability');
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute('available');
			pickUpAvailability.innerHTML = '';
		}
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
		)
			.then((response) => response.text())
			.then((responseText) => {
				const id = `price-${this.dataset.section}`;
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				const destination = document.getElementById(id);
				const source = html.getElementById(id);

				if (source && destination) destination.innerHTML = source.innerHTML;

				window.setPriceAccordingPickedOptions();

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove('visibility-hidden');
				this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');

		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add('visibility-hidden');
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"][id="variantsJson"]').textContent);
		return this.variantData;
	}

	getCurrentVariant() {
		return this.currentVariant;
	}
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset, length-selector-list')).filter(
			(fieldset) => {
				const isNotRingSizeFieldset = !fieldset.classList.contains('ring-size-fieldset');
				const containRadioInput = !!fieldset.querySelector('input[type="radio"]');
				const isNotFontOption = !!fieldset.querySelector('.custom-font-option');
				return isNotRingSizeFieldset && containRadioInput && !isNotFontOption;
			},
		);
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
		});
	}
}

customElements.define('variant-radios', VariantRadios);

//Recommendation products match metal

function setRecommendationVariant() {
	const metalEl = document.querySelector('.custom-select--metal .custom-option.active input');
	if (metalEl) {
		const metal = metalEl.value;
		const isDoubleMetal = metal.includes('&');

		document.querySelectorAll('.rebuy-product-options select')?.forEach((el) => {
			let elItem = Array.from(el.options).find((item, index, arr) => {
				return item.textContent.includes(metal);
			});
			if (!elItem) {
				elItem = Array.from(el.options).find((item) => {
					const metalColor = metalEl.getAttribute('data-metal-handle');
					const isOptionDouble = item.textContent.includes('&');
					const metalWithoutGold = metal.toLowerCase().replace('gold', '');

					if (isDoubleMetal && isOptionDouble) {
						const removeK = metal.split('K')[1];
						return item.textContent.includes(removeK);
					}
					return (
						item.textContent.toLowerCase().includes(metalWithoutGold) ||
						item.textContent.toLowerCase().includes(metalColor)
					);
				});
			}

			if (elItem) {
				const elItemValue = elItem.value;
				const event = new Event('change');
				el.value = elItemValue;
				el.dispatchEvent(event);
			}
		});
	}
}
window.triggerRecommendationShow = function triggerRecommendationShow() {
	const event = new CustomEvent('on-recommendation-show');
	document.dispatchEvent(event);
};

function recommendationShowMutation() {
	const observer = new MutationObserver((mutationsList) => {
		mutationsList.forEach((mutation) => {
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType === Node.ELEMENT_NODE) {
						if (node.nodeType === 1 && node.matches('.widget-type-product .rebuy-widget-content')) {
							document.addEventListener('on-recommendation-show', setRecommendationVariant);
							window.triggerRecommendationShow();
						}

						const targetChild = node?.querySelector('.widget-type-product .rebuy-widget-content');
						if (targetChild) {
							document.addEventListener('on-recommendation-show', setRecommendationVariant);
							window.triggerRecommendationShow();
						}
					}
				});
			}
		});
	});

	const config = { childList: true, subtree: true };

	observer.observe(document.body, config);
}
recommendationShowMutation();
